import { useMemo, useCallback } from "react";
import Dropdown from "./Dropdown";

const DropDownMediaType = ({
  value,
  onChange,
  options = [],
  optionsValue = [],
  disabled = false,
}) => {
  const mappedOptions = useMemo(() => {
    if (
      Array.isArray(options) &&
      options.length > 0 &&
      typeof options[0] === "object" &&
      options[0] !== null &&
      "label" in options[0] &&
      "value" in options[0]
    ) {
      return options;
    }

    const len = Math.min(options.length, optionsValue.length);
    return Array.from({ length: len }).map((_, idx) => ({
      label: options[idx],
      value: optionsValue[idx],
    }));
  }, [options, optionsValue]);

  const normalizedValue = useMemo(() => {
    if (typeof value !== "string") return "";
    if (mappedOptions.some((option) => option.value === value)) return value;

    const strippedValue = value.replace(/^.*\//, "").toLowerCase();
    const strippedMatch = mappedOptions.find(
      (option) => String(option.value).toLowerCase() === strippedValue,
    );

    return strippedMatch?.value || "";
  }, [mappedOptions, value]);

  const handleChange = useCallback(
    (arg) => {
      const nextValue = arg?.target ? arg.target.value : arg;
      onChange?.(nextValue);
    },
    [onChange],
  );

  return (
    <Dropdown
      variant="select"
      id="mediatype-select"
      value={normalizedValue}
      onChange={handleChange}
      options={mappedOptions}
      placeholderKey="dropdown.media_type"
      disabled={disabled}
    />
  );
};

export default DropDownMediaType;
